import { render, staticRenderFns } from "./LoanLayout.vue?vue&type=template&id=965ae4c2&scoped=true&"
import script from "./LoanLayout.vue?vue&type=script&lang=ts&"
export * from "./LoanLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "965ae4c2",
  null
  
)

export default component.exports